import {useCallback} from "react";
import {DashboardTimeRangeOptionType} from "../store/IDashboardPageStore";

export interface IDurationSwitcherLogic {
  isActive: (checkRange: DashboardTimeRangeOptionType) => boolean;
  getClassNameIfActive: (checkRange: DashboardTimeRangeOptionType, activeClassName: string) => string | undefined;
}

export const useDurationSwitcherLogic = (selectedRange: DashboardTimeRangeOptionType): IDurationSwitcherLogic => {
  const isActive = useCallback((checkRange: DashboardTimeRangeOptionType) => {
    return (checkRange === selectedRange);
  },
  [selectedRange]);

  const getClassNameIfActive = useCallback((checkRange: DashboardTimeRangeOptionType, activeClassName: string): string | undefined => {
    return isActive(checkRange) ? `${activeClassName}` : undefined
  }, [isActive]);
  return {
    isActive,
    getClassNameIfActive,
  };
}
